import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createTheme, ThemeProvider } from "@mui/material";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store";
import { BrowserRouter } from "react-router-dom";
import logoShell from "./images/logoShell.png";
import logoYpf from "./images/logoYpf.png";
import logoYpfPago from "./images/ypf-icon.png";
import logoShellPago from "./images/shell-box-icon.png";
import logoAxionPago from "./images/icono-on.png";
import logoAxion from "./images/axion.png";
import logoPuma from "./images/logo-puma.png";
import logoGulf from "./images/gulf-logo.png";
import logoDapsa from "./images/dapsa-logo.png";
import refinor from "./images/refinor-logo3.png";
import logoVoy from "./images/voy-logo.png";
import logoCaldenMobilePOSv2 from "./images/logoCaldenMobilePOSv2.png";
import fullImg from "./images/fullSinFondo.svg";
import tiendaImg from "./images/tienda.svg";
import qr from "./images/qr-btn.png";

// Configuración para cada marca
const configuraciones = {
  sinBandera: {
    colorPrimario: "#1D4E9C",
    colorHeader: "#1D4E9C",
    colorIconoHeader: "#fff",
    colorSecundario: "#1D4E9C",
    image: logoCaldenMobilePOSv2,
    colorLogin: "#fff",
    logoPago: qr,
    anchoLogo: 100,
    labelTienda: "TIENDA",
    tiendaLogo: tiendaImg,
    anchoLogoTienda: "110px",
    navigationLogoTiendaAncho: "50px",
    textoBotonPago: "QR",
  },
  ypf: {
    colorPrimario: "#005090",
    colorHeader: "#005090",
    colorIconoHeader: "#fff",
    colorSecundario: "#005090",
    image: logoYpf,
    colorLogin: "#fff",
    logoPago: logoYpfPago,
    anchoLogo: "50px",
    labelTienda: "FULL",
    tiendaLogo: fullImg,
    anchoLogoTienda: "58px",
    navigationLogoTiendaAncho: "30px",
    textoBotonPago: "YPF APP",
  },
  shell: {
    colorPrimario: "#FBCE07",
    colorHeader: "#FBCE07",
    colorIconoHeader: "#fff",
    colorSecundario: "#dd1d21",
    image: logoShell,
    colorLogin: "#000",
    logoPago: logoShellPago,
    anchoLogo: "50px",
    textoBotonPago: "SHELL BOX",
  },
  axion: {
    colorPrimario: "#101760",
    colorHeader: "#101760",
    colorIconoHeader: "#fff",
    colorSecundario: "#CA117C",
    image: logoAxion,
    anchoLogo: "50px",
    colorLogin: "#000",
    logoPago: logoAxionPago,
    textoBotonPago: "AXION ON",
  },
  puma: {
    colorPrimario: "#00784A",
    colorHeader: "#fff",
    colorIconoHeader: "#db1f2a",
    colorSecundario: "#DB1F2A",
    image: logoPuma,
    anchoLogo: "140px",
    colorLogin: "#000",
    textoBotonPago: "",
  },
  gulf: {
    colorPrimario: "#002776",
    colorHeader: "#002776",
    colorIconoHeader: "#fff",
    colorSecundario: "#FF6319",
    image: logoGulf,
    anchoLogo: "40px",
    colorLogin: "#000",
    textoBotonPago: "",
  },
  refinor: {
    colorPrimario: "#6B8C2D",
    colorHeader: "#B6D70B",
    colorIconoHeader: "#fff",
    colorSecundario: "#6B8C2D",
    image: refinor,
    anchoLogo: "160px",
    colorLogin: "#000",
    textoBotonPago: "",
  },
  dapsa: {
    colorPrimario: "#fff",
    colorHeader: "#fff",
    colorIconoHeader: "#000",
    colorSecundario: "#E01C24",
    image: logoDapsa,
    anchoLogo: "120px",
    colorLogin: "#000",
    textoBotonPago: "",
  },
  voy: {
    colorPrimario: "#9F1857",
    colorHeader: "#9F1857",
    colorIconoHeader: "#fff",
    colorSecundario: "#9F1857",
    image: logoVoy,
    anchoLogo: "60px",
    colorLogin: "#000",
    textoBotonPago: "",
  },
  // Agrega más configuraciones aquí según sea necesario
};

// Función para obtener la configuración basada en la marca
const getTheme = marca => {
  const bandera = configuraciones[marca] || configuraciones.axion; // valor por defecto si no se encuentra la marca
  return createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 650,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
    bandera: bandera,
  });
};

const RootComponent = () => {
  const [theme, setTheme] = useState(getTheme(localStorage.getItem("bandera")));

  useEffect(() => {
    const updateTheme = () => {
      const storedMarca = localStorage.getItem("bandera");
      const newTheme = getTheme(storedMarca);
      setTheme(newTheme);
    };
    
    const handleBanderaChange = () => {
      updateTheme();
    };
    
    updateTheme();
    window.addEventListener("storage", updateTheme);
    window.addEventListener("banderaChanged", handleBanderaChange);
    
    return () => {
      window.removeEventListener("storage", updateTheme);
      window.removeEventListener("banderaChanged", handleBanderaChange);
    };
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootComponent />);
reportWebVitals();
